'use strict';

/**
 *
 * @name: UserConfig
 *
 */

function UserConfig($stateProvider) {

  'ngInject';

  function _resolveModuleControllers($ocLazyLoad) {

    return $ocLazyLoad.load('UserBundle');
  }

  $stateProvider
    .state('main.twitter', {
      url: 'twitter',
      controller: 'TwitterController',
      resolve: {
        moduleControllers: _resolveModuleControllers
      },
      templateProvider: $templateCache => $templateCache.get('twitter.index.html')
    })
    .state('main.linkedin', {
      url: 'linkedin',
      controller: 'LinkedinController',
      resolve: {
        moduleControllers: _resolveModuleControllers
      },
      templateProvider: $templateCache => $templateCache.get('linkedin.index.html')
    })
    .state('main.douban', {
      url: 'douban',
      controller: 'DoubanController',
      resolve: {
        moduleControllers: _resolveModuleControllers
      },
      templateProvider: $templateCache => $templateCache.get('douban.index.html')
    })
    .state('main.weibo', {
      url: 'weibo',
      controller: 'WeiboController',
      resolve: {
        moduleControllers: _resolveModuleControllers
      },
      templateProvider: $templateCache => $templateCache.get('weibo.index.html')
    })
    .state('main.forgot', {
      url: 'forgot-password',
      controller: 'ForgotPasswordController',
      resolve: {
        moduleControllers: _resolveModuleControllers
      },
      templateProvider: $templateCache => $templateCache.get('forgot-password.index.html')
    })
    .state('main.resetPassword', {
      url: 'reset-password/:id/:resetToken',
      controller: 'ResetPasswordController',
      resolve: {
        moduleControllers: _resolveModuleControllers
      },
      templateProvider: $templateCache => $templateCache.get('reset-password.index.html')
    })
    .state('main.verify', {
      url: 'verify',
      controller: 'VerifyController',
      resolve: {
        moduleControllers: _resolveModuleControllers
      },
      templateProvider: $templateCache => $templateCache.get('verify.index.html')
    });
}

export default UserConfig;



// WEBPACK FOOTER //
// ./app/pages/user/user.config.js